import { FunctionComponent } from 'react';
import { Button, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';

const PREFIX = 'pages.application_championship_stage_standings.header_actions';

type StandingsHeaderActionsProps = {
  onAdd: () => void;
  isDisabled?: boolean;
  /** Motivo de desabilitar — exibido em tooltip se isDisabled. */
  disabledReason?: string;
};

export const StandingsHeaderActions: FunctionComponent<StandingsHeaderActionsProps> = ({
  onAdd,
  isDisabled = false,
  disabledReason,
}) => {
  const { t } = useTranslation();

  const button = (
    <Button
      onClick={onAdd}
      isDisabled={isDisabled}
      leftIcon={<ChakraFeatherIcon name="plus-circle" boxSize="16px" />}
      variant="outline"
    >
      {t(`${PREFIX}.add_team`)}
    </Button>
  );

  if (isDisabled && disabledReason) {
    return (
      <Tooltip label={disabledReason} hasArrow placement="bottom-end">
        {/* span necessário porque Button disabled não dispara mouse events */}
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
